export function isInvoice(arg: any): arg is IInvoice {
  return Object.keys(arg).every(
    key => typeof arg[key] === 'string'
    || typeof arg[key] === 'number'
    || arg[key] === null,
  );
}

export function isInvoiceList(arg: any): arg is IInvoiceList {
  return Array.isArray(arg) && arg.every(isInvoice);
}
